const base64ToBlob = async (base64Data: string): Promise<Blob> => {
  const response = await fetch(`data:image/png;base64,${base64Data}`)
  return await response.blob()
}

export const downloadImage = (imageData: string, fileName?: string) => {
  const link = document.createElement('a')
  link.setAttribute('href', imageData)
  link.setAttribute('download', fileName ?? 'download')
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  return true
}

export const clipImage = async (imageData: string) => {
  const blobImgData = await base64ToBlob(
    imageData.replace('data:image/png;base64,', '')
  )
  const clipboardItem = new ClipboardItem({
    [blobImgData.type]: blobImgData
  })
  return await navigator.clipboard.write([clipboardItem])
}
